var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeProductivity3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5235:28873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4512 14.5H32.3212C31.8764 10.9767 30.272 7.70145 27.7609 5.1903C25.2497 2.67915 21.9745 1.07481 18.4512 0.630005V14.5Z",
    fill: "#FF5630"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4512 16.5V0.5C13.2867 0.5 10.1932 1.43838 7.56206 3.19649C4.93087 4.95459 2.88011 7.45345 1.66911 10.3771C0.458104 13.3007 0.141251 16.5177 0.758615 19.6214C1.37598 22.7251 2.89983 25.5761 5.13747 27.8137C7.37511 30.0513 10.226 31.5752 13.3297 32.1926C16.4334 32.8099 19.6505 32.4931 22.5741 31.2821C25.4977 30.0711 27.9966 28.0203 29.7547 25.3891C31.5128 22.7579 32.4512 19.6645 32.4512 16.5H16.4512Z",
    fill: "#FF5630"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5235:28873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.451172 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeProductivity3);
export default __webpack_public_path__ + "static/media/homeProductivity_3.b0634704.svg";
export { ForwardRef as ReactComponent };